export const resources = {
  junior: {
    macos: [
      { name: 'UX Research Fundamentals', url: 'https://www.nngroup.com/articles/which-ux-research-methods/', type: 'methodology' },
      { name: 'Usability Testing Guide', url: 'https://www.usability.gov/how-to-and-tools/methods/usability-testing.html', type: 'testing' },
      { name: 'User Interview Techniques', url: 'https://www.uxbooth.com/articles/the-art-of-the-user-interview/', type: 'interviews' },
      { name: 'Survey Design Best Practices', url: 'https://www.surveymonkey.com/mp/survey-design-best-practices/', type: 'surveys' }
    ],
    windows: [
      { name: 'Microsoft Research Methods', url: 'https://docs.microsoft.com/en-us/microsoft-365/solutions/design-principles', type: 'methodology' },
      { name: 'Forms for User Research', url: 'https://support.microsoft.com/en-us/office/create-a-form-with-microsoft-forms', type: 'tools' },
      { name: 'Teams for Research Sessions', url: 'https://docs.microsoft.com/en-us/microsoftteams/meeting-recording', type: 'collaboration' },
      { name: 'Excel for Data Analysis', url: 'https://support.microsoft.com/en-us/office/analyze-data-in-excel', type: 'analysis' }
    ],
    linux: [
      { name: 'Open Source Research Tools', url: 'https://github.com/topics/user-research', type: 'tools' },
      { name: 'R for UX Research', url: 'https://www.r-project.org/', type: 'statistics' },
      { name: 'Python for Research Analysis', url: 'https://pandas.pydata.org/docs/getting_started/intro_tutorials/', type: 'analysis' },
      { name: 'LibreOffice for Research', url: 'https://www.libreoffice.org/', type: 'documentation' }
    ]
  },
  mid: {
    macos: [
      { name: 'Advanced Research Methods', url: 'https://www.nngroup.com/articles/ux-research-cheat-sheet/', type: 'advanced' },
      { name: 'Quantitative UX Research', url: 'https://www.nngroup.com/articles/quantitative-user-research-methods/', type: 'quantitative' },
      { name: 'Research Operations', url: 'https://www.nngroup.com/articles/research-operations/', type: 'operations' },
      { name: 'Behavioral Analytics', url: 'https://www.hotjar.com/blog/behavioral-analytics/', type: 'analytics' }
    ],
    windows: [
      { name: 'Power BI for Research', url: 'https://powerbi.microsoft.com/en-us/learning/', type: 'visualization' },
      { name: 'Azure Cognitive Services', url: 'https://docs.microsoft.com/en-us/azure/cognitive-services/', type: 'ai-research' },
      { name: 'Advanced Forms Analytics', url: 'https://docs.microsoft.com/en-us/microsoft-365/admin/activity-reports/', type: 'analytics' },
      { name: 'SharePoint for Research', url: 'https://docs.microsoft.com/en-us/sharepoint/', type: 'collaboration' }
    ],
    linux: [
      { name: 'Advanced Python Analytics', url: 'https://scikit-learn.org/stable/', type: 'machine-learning' },
      { name: 'Jupyter for Research', url: 'https://jupyter.org/', type: 'analysis' },
      { name: 'PostgreSQL for Research Data', url: 'https://www.postgresql.org/docs/', type: 'database' },
      { name: 'Docker for Research Environments', url: 'https://docs.docker.com/', type: 'environment' }
    ]
  },
  senior: {
    macos: [
      { name: 'Research Strategy', url: 'https://www.nngroup.com/articles/ux-research-strategy/', type: 'strategy' },
      { name: 'Research Leadership', url: 'https://medium.com/design-research/building-a-research-practice-cf85cd5c553e', type: 'leadership' },
      { name: 'Advanced Analytics', url: 'https://www.nngroup.com/articles/analytics-user-experience/', type: 'analytics' },
      { name: 'Research Impact Measurement', url: 'https://dscout.com/people-nerds/measuring-research-impact', type: 'impact' }
    ],
    windows: [
      { name: 'Enterprise Research Platforms', url: 'https://docs.microsoft.com/en-us/azure/architecture/', type: 'enterprise' },
      { name: 'AI-Powered Research', url: 'https://docs.microsoft.com/en-us/azure/cognitive-services/text-analytics/', type: 'ai' },
      { name: 'Advanced Power Platform', url: 'https://powerapps.microsoft.com/en-us/', type: 'automation' },
      { name: 'Microsoft Viva Insights', url: 'https://docs.microsoft.com/en-us/viva/insights/', type: 'insights' }
    ],
    linux: [
      { name: 'Machine Learning for UX', url: 'https://tensorflow.org/', type: 'ml' },
      { name: 'Big Data Analytics', url: 'https://spark.apache.org/', type: 'big-data' },
      { name: 'Research Automation', url: 'https://github.com/topics/research-automation', type: 'automation' },
      { name: 'Open Source Research Stack', url: 'https://github.com/topics/research-platform', type: 'platform' }
    ]
  }
};
